import React from 'react';

import { StyledInputText, Wrapper, Label, DateText, DateLabel } from './InputText.styles';
import { Icon } from '../../Icon';

export const InputText = ({ type = 'text', ...props }) => {
  return <StyledInputText {...props} type={type} />;
};

export const Input = ({
  type = 'text',
  label,
  className,
  id,
  placeholder,
  fullWidth,
  ...props
}) => {
  return (
    <Wrapper className={className} fullWidth={fullWidth}>
      {label && <Label>{label}</Label>}
      {type === 'date' ? (
        <>
          <DateText htmlFor={id} style={{ zIndex: 1 }}>
            <DateLabel fontSize={16}>{props.value ? props.value : placeholder}</DateLabel>
            <Icon>{'Calendar'}</Icon>
          </DateText>
          <StyledInputText
            onClick={e => e.target.showPicker()}
            id={id}
            {...props}
            type={type}
            style={{
              border: 'none',
              boxSizing: 'border-box',
              outline: '0',
              padding: 0,
              opacity: 0,
              height: 0,
              position: 'absolute'
            }}
          />
        </>
      ) : (
        <StyledInputText {...props} type={type} />
      )}
    </Wrapper>
  );
};
